import { createCommunityAuthContext } from './createCommunityAuthContext';

const { Provider: CapsAuthProvider, useAuth: useCapsAuth } = createCommunityAuthContext({
  community: 'caps',
});

export { CapsAuthProvider, useCapsAuth };
